
import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { CROP_PRODUCT_OPTIONS } from '../constants/cropProducts';

export default function ChartsOverviewDemo(props) {

  const adder=(data, product)=>{
    var sorter = data.filter(bug=>bug.product===product)
    var total=0
    for (var i in sorter){
      total+=parseFloat(sorter[i].amount)
    }
    
    return total
    
      }

      
  return (
    <BarChart
      series={[
        { data: CROP_PRODUCT_OPTIONS.map((product) => adder(props.sales, product)) }
      ]}
      height={200}
      xAxis={[{ data: CROP_PRODUCT_OPTIONS, scaleType: 'band' }]}
      margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
    />
  );
}
